"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CampaignInfluencerMethods = exports.CampaignInfluencer = void 0;

var _moment = _interopRequireDefault(require("moment"));

var _influencer = require("./influencer");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var CampaignInfluencerMethods = /*#__PURE__*/function () {
  function CampaignInfluencerMethods() {
    _classCallCheck(this, CampaignInfluencerMethods);
  }

  _createClass(CampaignInfluencerMethods, null, [{
    key: "isPending",
    value: function isPending(campaignInfluencer) {
      return campaignInfluencer.status === 'pending';
    }
  }, {
    key: "isDeclined",
    value: function isDeclined(campaignInfluencer) {
      return campaignInfluencer.status === 'declined';
    }
  }, {
    key: "isAccepted",
    value: function isAccepted(campaignInfluencer) {
      return campaignInfluencer.status === 'accepted';
    }
  }, {
    key: "brandHasUnreadMessages",
    value: function brandHasUnreadMessages(campaignInfluencer) {
      var _campaignInfluencer$c;

      return ((_campaignInfluencer$c = campaignInfluencer.campaign_message_unread_count) !== null && _campaignInfluencer$c !== void 0 ? _campaignInfluencer$c : 0) > 0;
    }
  }, {
    key: "brandHasUnreadAttachments",
    value: function brandHasUnreadAttachments(campaignInfluencer) {
      var _campaignInfluencer$c2;

      return ((_campaignInfluencer$c2 = campaignInfluencer.campaign_message_unread_attachment_count) !== null && _campaignInfluencer$c2 !== void 0 ? _campaignInfluencer$c2 : 0) > 0;
    }
  }, {
    key: "creatorHasUnreadMessages",
    value: function creatorHasUnreadMessages(campaignInfluencer) {
      var _campaignInfluencer$u;

      return ((_campaignInfluencer$u = campaignInfluencer.unread_messages_count) !== null && _campaignInfluencer$u !== void 0 ? _campaignInfluencer$u : 0) > 0;
    }
  }, {
    key: "getLastMessagedAtMoment",
    value: function getLastMessagedAtMoment(campaignInfluencer) {
      return (0, _moment["default"])(campaignInfluencer.last_messaged_at || campaignInfluencer.created_at);
    }
  }, {
    key: "isOrderSubmitted",
    value: function isOrderSubmitted(campaignInfluencer) {
      return !!campaignInfluencer.p4p_order_id;
    }
  }]);

  return CampaignInfluencerMethods;
}();
/**
 * @deprecated - use the campaign influencer methods instead
 */


exports.CampaignInfluencerMethods = CampaignInfluencerMethods;

var CampaignInfluencer = /*#__PURE__*/function (_Influencer) {
  _inherits(CampaignInfluencer, _Influencer);

  var _super = _createSuper(CampaignInfluencer);

  /**
   * This comes from distillery and is the number of messages that have been sent by the influencer 
   * to the brand and not read by the brand yet
   */

  /**
   * This comes from distillery and is the number of attachments that have been sent by the influencer 
   * to the brand and not read by the brand yet
   */

  /**
   * Number of messages sent by the brand to the influencer, not read by the influencer yet
   */
  function CampaignInfluencer(data) {
    _classCallCheck(this, CampaignInfluencer);

    return _super.call(this, data);
  }

  _createClass(CampaignInfluencer, [{
    key: "isPending",
    value: function isPending() {
      return this.status === 'pending';
    }
  }, {
    key: "isDeclined",
    value: function isDeclined() {
      return this.status === 'declined';
    }
  }, {
    key: "isAccepted",
    value: function isAccepted() {
      return this.status === 'accepted';
    }
  }, {
    key: "brandHasUnreadMessages",
    value: function brandHasUnreadMessages() {
      var _this$campaign_messag;

      return ((_this$campaign_messag = this.campaign_message_unread_count) !== null && _this$campaign_messag !== void 0 ? _this$campaign_messag : 0) > 0;
    }
  }, {
    key: "brandHasUnreadAttachments",
    value: function brandHasUnreadAttachments() {
      var _this$campaign_messag2;

      return ((_this$campaign_messag2 = this.campaign_message_unread_attachment_count) !== null && _this$campaign_messag2 !== void 0 ? _this$campaign_messag2 : 0) > 0;
    }
  }, {
    key: "creatorHasUnreadMessages",
    value: function creatorHasUnreadMessages() {
      var _this$unread_messages;

      return ((_this$unread_messages = this.unread_messages_count) !== null && _this$unread_messages !== void 0 ? _this$unread_messages : 0) > 0;
    }
  }, {
    key: "getLastMessagedAtMoment",
    value: function getLastMessagedAtMoment() {
      return (0, _moment["default"])(this.last_messaged_at || this.created_at);
    }
  }, {
    key: "isOrderSubmitted",
    value: function isOrderSubmitted() {
      return !!this.p4p_order_id;
    }
  }]);

  return CampaignInfluencer;
}(_influencer.Influencer);

exports.CampaignInfluencer = CampaignInfluencer;